<template>
  <div>
    <div class="elasticsearchResource-title">
      <div>{{ $t("RAM.AWS.Elasticsearch.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticsearch:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticsearch:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="elasticsearchResource-top">
      <elasticsearch-resource-search
        ref="elasticsearchResourceSearchChild"
      ></elasticsearch-resource-search>
    </div>
    <table-elasticsearch-resource></table-elasticsearch-resource>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import ElasticsearchResourceSearch from "../elasticsearch/ElasticsearchResourceSearch";
import TableElasticsearchResource from "../elasticsearch/TableElasticsearchResource";
import Export from "../../aws/Export";

export default {
  name: "ElasticsearchResource",
  components: {
    ElasticsearchResourceSearch,
    TableElasticsearchResource,
    Export
  },
  data() {
    return {
      loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.elasticsearchResourceSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 17
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.$refs.exportChild.openExport(3);
    },
    export: function(chooseType) {
      // 获取子组件数据
      var exportDTO = {
        companyId: this.$refs.elasticsearchResourceSearchChild.companyId
      };
      // 点击 是
      if (chooseType == true) {
        this.$refs.exportChild.loading = true;
        exportDTO.exportWithTag = true;
      }
      // 点击 否
      else {
        this.$refs.exportChild.modal_loading = true;
        exportDTO.exportWithTag = false;
      }
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSElasticsearch(exportDTO)
        .then(res => {
          let fileName = "Elasticsearch.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          if (chooseType == true) {
            this.$refs.exportChild.loading = false;
          } else {
            this.$refs.exportChild.modal_loading = false;
          }
          // 关闭导出弹出框
          this.$refs.exportChild.exportModal = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.elasticsearchResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.elasticsearchResource-title > div:nth-child(1) {
  float: left;
}
.elasticsearchResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.elasticsearchResource-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/elasticsearch/ElasticsearchResource.vue